export default {
    data: () => ({

        tech_map: {
            name: null,
            composite_items: []
        },

        tech_maps: [],
        page: 1,
    }),
    methods: {
        async getByIdTechMap(go_back = false, service = '') {
            const result = this.$communicator.then(
                this,
                await this.$communicator("tech_map_get_by_id", {
                    params: {
                        _id: this.tech_map_id,
                        service
                    }
                })
            );
            if (!result && go_back) {
                this.goBack();
            }
            this.tech_map = result;
        },
        async getTechMapByItemId(item_id) {
            const result = this.$communicator.then(
                this,
                await this.$communicator("tech_map_get_by_item_id", {
                    params: {
                        item_id
                    }
                })
            );
            this.tech_map = result;
        },
        async getTechMap(search = '') {
            const result = this.$communicator.then(
                this,
                await this.$communicator("tech_map_get", {
                    params: {
                        limit: 10,
                        page: this.page,
                        search
                    }
                })
            );
            if (result && result.data instanceof Array) {
                this.tech_maps = result.data;
                this.num_pages = Math.ceil(result.total / 10);
            } else {
                this.tech_maps = [];
                this.num_pages = 1;
            }
        }
    }
}